import { render, staticRenderFns } from "./123.vue?vue&type=template&id=fdb0452e&scoped=true&"
var script = {}
import style0 from "./123.vue?vue&type=style&index=0&id=fdb0452e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb0452e",
  null
  
)

export default component.exports